import { DomainBase } from "./DomainBase";

  export class DiscountClass extends DomainBase {
    constructor() {
        super();
        this.name = "";
        this.percentage = 0;
    }
}
  